import { desk } from '@isyscore/messenger';
import { logout } from '@/service/system';
import store from '../../../store';
import { openAlert, showError, showWarning } from '@/utils/message.ts';
import AppManager from '@/store/modules/app-manager/app-manager.class';
import { record } from '../../../sdk/collect/visit';

function locationToSSO() {
    const returnUrl = encodeURIComponent(location.href);
    location.assign(`${ENVS.ssoUrl}?return=${returnUrl}`);
}

const { receive } = desk;

// user channel
receive('user:login', locationToSSO);
receive('user:logout', async () => {
    try {
        await logout();
    } catch (e) {
        return showError('登出失败：' + e);
    }

    locationToSSO();
});

// topBar channel
/**
 * @deprecated
 * 已在 os2021.1230 废弃
 */
receive('topBar:show', () => {
    showWarning('topBar:show 事件已废弃');
});
receive('topBar:hide', () => {
    showWarning('topBar:hide 事件已废弃，需要全屏展示的应用可以将应用打开方式设置为新窗口打开');
});

export async function receiveLicenseInvalid() {
    await openAlert('OS未授权，请联系供应商');
    AppManager.getInstance().openApp('system-manage', '/about-os');
}
receive('license:invalid', receiveLicenseInvalid);

receive('report:userAction', (visitAction) => {
    record(visitAction);
});

// navigator channel
receive('navigator:home', async () => {
    store.commit('desk/showHeader');
});

receive('navigator:loginPage', locationToSSO);

receive('navigator:app', async ({ appCode, to }) => {
    AppManager.getInstance().openApp(appCode, to);
});

receive('navigator:replaceApp', async ({ appCode, to }) => {
    AppManager.getInstance().replaceApp(appCode, to);
});

// 刷新应用菜单
receive('navigator:refresh', async () => {
    await store.dispatch('desk/getAllowedApps');
});

receive('navigator:url', (payload) => {
    // addQuery(payload);
    AppManager.getInstance().updateDesktopUrl(payload);
});

receive('unknown', (payload, ev) => {
    console.log('未知命令', ev.data);
});
